import { budgetChargeTypes, budgetAmountStates, budgetComparatorTypes, budgetLineProblem } from './budget-workflow.js';
export const budgetTemplateColumns = ['Cost category', 'Description', 'Amount including VAT', 'Who contributes', 'Explanation', 'Charge treatment', 'Amount meaning', 'Comparison type', 'Comparison amount', 'Participating properties', 'Funded from', 'Net if known', 'VAT if known', 'Row ID', 'Calculation basis', 'Coverage amount', 'Coverage from', 'Coverage to'];
export function readBudgetTemplate(sheets, codes) {
    const setup = sheets.find(s => s.name === 'Budget'), costs = sheets.find(s => s.name === 'Costs');
    if (!setup || !costs || !['BlockGenie Budget 1', 'Blocular Budget 1'].includes(setup.rows[1]?.[1] ?? ''))
        throw Error('Use the BlockGenie budget template. Keep the Budget and Costs worksheets.');
    const get = (label) => setup.rows.find(r => r[0] === label)?.[1]?.trim() ?? '';
    if (!budgetTemplateColumns.every((h, i) => costs.rows[0]?.[i] === h))
        throw Error('Keep the Costs column headings from the downloaded template.');
    const errors = [], ids = new Set();
    const lines = costs.rows.slice(1).map((r, index) => ({ r, index })).filter(({ r }) => r.some(v => v.trim())).map(({ r, index }) => {
        const value = (i) => r[i]?.trim() ?? '', code = value(0).split(' · ')[0], matched = codes.filter(c => c.code === code), rowId = value(13) || `source-${index + 2}`;
        const line = { rowId, sourceCategory: value(0), description: value(1) || matched[0]?.name || '', sourceDescription: value(1) || matched[0]?.name || '', sourceRow: index + 2, costCodeId: matched.length === 1 ? matched[0].id : null, gross: value(2), splitRuleId: value(3) === 'Residential' ? 'residential-only' : value(3) === 'Commercial' ? 'commercial-only' : value(3) === 'Selected schedule' ? '' : value(3), explanation: value(4), chargeType: (value(5) || 'Service charge'), amountState: (value(6) || 'Amount'), net: value(11) || null, vat: value(12) || null };
        if (value(7))
            line.comparatorType = value(7);
        if (value(8))
            line.comparatorAmount = value(8);
        if (value(9))
            line.propertyReference = value(9);
        if (value(10))
            line.fundingSource = value(10);
        if (value(14)) {
            if (!['Recurring', 'One-off'].includes(value(14)))
                errors.push(`Row ${index + 2}: choose Recurring or One-off.`);
            line.calculation = { basis: value(14), amount: value(15), startsOn: value(16), endsOn: value(17) };
        }
        if (ids.has(rowId))
            errors.push(`Row ${index + 2}: duplicate Row ID ${rowId}.`);
        ids.add(rowId);
        if (!line.costCodeId)
            errors.push(`Row ${index + 2}: unknown cost category ${code || '(blank)'}. Choose an existing category.`);
        if (!budgetChargeTypes.includes(line.chargeType))
            errors.push(`Row ${index + 2}: choose a listed charge treatment.`);
        if (!budgetAmountStates.includes(line.amountState))
            errors.push(`Row ${index + 2}: choose a listed amount meaning.`);
        if (line.comparatorType && !budgetComparatorTypes.includes(line.comparatorType))
            errors.push(`Row ${index + 2}: choose a listed comparison type.`);
        try {
            const problem = budgetLineProblem(line);
            if (problem)
                errors.push(`Row ${index + 2}: ${problem}`);
        }
        catch (e) {
            errors.push(`Row ${index + 2}: ${e.message}`);
        }
        return line;
    });
    if (!lines.length)
        errors.push('Add at least one cost row.');
    const rules = (sheets.find(s => s.name === 'Shared rules')?.rows.slice(1) ?? []).filter(r => r.some(v => v.trim())).map(r => ({ id: r[0] ?? '', name: r[1] ?? '', residential: r[2] ?? '', commercial: r[3] ?? '' }));
    return { rules, scheduleId: get('Schedule ID'), commercialScheduleId: get('Commercial schedule ID'), reserveContribution: get('Reserve contribution') || '0', commercialReserveContribution: get('Commercial reserve contribution') || '0', title: get('Budget title'), startsOn: get('Starts on'), endsOn: get('Ends on'), notes: get('Notes'), lines, errors };
}
//# sourceMappingURL=budget-template.js.map